import { Box } from "@mui/material";
import { useEffect, useRef } from "react";
import LogoSVG from "../../../images/svg/logo_anim/logo_anim";

const SplashScreenComponent = () => {
  const splashScreenRef = useRef();
  const splashAnim = () => {
    const splashScreen = splashScreenRef.current;
    splashScreen.classList.add("active");
  };
  useEffect(() => {
    splashAnim();
  }, []);
  return (
    <Box id="splashScreen" ref={splashScreenRef}>
      <LogoSVG />
    </Box>
  );
};

export default SplashScreenComponent;
